module.exports = __webpack_public_path__ + "static/img/PH.c7554558.png";